/**
 * Scroll Animations — Daisy Connected Shop
 * Ported from WP theme scroll-animations.js.
 * Intersection Observer system for data-animate attributes.
 */

(function () {
  'use strict';

  var THRESHOLD = 0.1;
  var ROOT_MARGIN = '0px 0px -100px 0px';
  var ANIMATED_CLASS = 'animated';

  /**
   * Check if user prefers reduced motion
   */
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Handle intersection entries
   */
  function handleIntersection(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var target = entry.target;
      var delay = parseInt(target.getAttribute('data-delay'), 10) || 0;

      setTimeout(function () {
        target.classList.add(ANIMATED_CLASS);
      }, delay);

      observer.unobserve(target);
    });
  }

  /**
   * Initialize scroll animations
   */
  function init() {
    var elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;

    /* If reduced motion, show everything immediately */
    if (prefersReducedMotion()) {
      elements.forEach(function (el) {
        el.classList.add(ANIMATED_CLASS);
      });
      return;
    }

    var observer = new IntersectionObserver(handleIntersection, {
      threshold: THRESHOLD,
      rootMargin: ROOT_MARGIN
    });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
